<agr-wrapper-site-sidenav data-test="site-root">
  <app-information-banner *ngIf="showSapMaintenanceWarning"></app-information-banner>
  <router-outlet></router-outlet>
</agr-wrapper-site-sidenav>
